module.exports = __webpack_public_path__ + "static/media/startup-sound.24addf66.wav";